export default "__VITE_ASSET__DmIRQ$lH__"